import { ProductEditorInputHelper } from '../../../../../Creator/Setting/F/frame/initProductEditorEvents';
import { checkAllEvents, getEditorContainerEl } from './fn.js';

export const changeCheckSaleEndDate = (e: InputEvent, product_editor_helper: ProductEditorInputHelper) => {
  const target = e.currentTarget as HTMLInputElement | null;
  const view = product_editor_helper.view.판매종료일;
  if (target && view) {
    view.setVisible(target.checked);
    view.setRequiredAndSync(target.checked);

    if (!target.checked) {
      view.clear();
    }

    const container_el = getEditorContainerEl(target);
    checkAllEvents(container_el);
  }
};

export const changeCheckMaxPurchasePerUser = (e: Event, product_editor_helper: ProductEditorInputHelper) => {
  const target = e.currentTarget as HTMLInputElement | null;
  const view = product_editor_helper.view.인당구매수량제한;

  if (target && view) {
    view.setVisible(target.checked);
    view.setRequiredAndSync(target.checked);

    if (!target.checked) {
      view.clear();
    }

    const container_el = getEditorContainerEl(target);
    checkAllEvents(container_el);
  }
};

export const changeCheckQuantity = (e: Event, product_editor_helper: ProductEditorInputHelper) => {
  const target = e.currentTarget as HTMLInputElement | null;
  const view = product_editor_helper.view.한정판매수량;

  if (target && view) {
    view.setVisible(target.checked);
    view.setRequiredAndSync(target.checked);

    if (!target.checked) {
      view.clear();
    }

    const container_el = getEditorContainerEl(target);
    checkAllEvents(container_el);
  }
};

export const checkAllEventsHandler = (e: Event) => {
  const target = e.currentTarget as HTMLInputElement | null;
  const container_el = getEditorContainerEl(target);

  checkAllEvents(container_el);
};
